import {
  Wind, Syringe, Baby, Thermometer, Apple, Sun, Stethoscope, Droplet, Heart, Brain, Bone, Eye, Ear,
  Activity, Shield, Pill, Smile, Microscope, Bandage, Hospital, Scale, Ribbon, Sparkles, HandHeart,
} from "lucide-react";

export const ICONS = {
  wind: Wind, syringe: Syringe, baby: Baby, thermometer: Thermometer, apple: Apple, sun: Sun,
  stethoscope: Stethoscope, droplet: Droplet, heart: Heart, brain: Brain, bone: Bone, eye: Eye, ear: Ear,
  activity: Activity, shield: Shield, pill: Pill, smile: Smile, microscope: Microscope, bandage: Bandage,
  hospital: Hospital, scale: Scale, ribbon: Ribbon, sparkles: Sparkles, "hand-heart": HandHeart,
};

export const ICON_NAMES = Object.keys(ICONS);
